/* eslint-disable react/react-in-jsx-scope */

import { store } from 'redux/store';
import Swal from 'sweetalert2';
import { setModal } from 'modules/_shared/redux/modalActions';
import AddDraftInvestorModal from 'modules/_shared/components/Modals/AddDraftInvestorModal';
import { AddDraftInvestorModalProvider } from 'modules/_shared/components/Modals/AddDraftInvestorModal/context/AddDraftInvestorModalContext';
import actionTypes from 'constants/actionTypes';

function menuOptions(i18n) {
  return [
    {
      icon: 'ni-edit',
      text: i18n.t('Edit'),
      action: ({
        updatePartnerToDraft,
        partnerData,
        currentDraft,
        discountPercent,
        dueDate,
        draftType,
        setTouched,
      }) => {
        store.dispatch(
          setModal(
            <AddDraftInvestorModalProvider
              modalActionType={actionTypes.EDIT}
              draftType={draftType}
              draftStatus={currentDraft?.status}
              draftInvestorToEdit={partnerData}
              handleUpdateInvestorInDraft={updatePartnerToDraft}
              draftConditions={{
                discountPercent,
                dueDate,
              }}
              setTouched={setTouched}
            >
              <AddDraftInvestorModal />
            </AddDraftInvestorModalProvider>
          )
        );
      },
    },
    {
      icon: 'ni-trash',
      text: i18n.t('Delete'),
      action: ({ partnerData, removePartnerFromDraft }) => {
        Swal.fire({
          icon: 'warning',
          title: `<h4 className="nk-block-title page-title">${i18n.t(
            'SureYouWantToDeleteInvestorContribution'
          )}  `,
          html: `<h3 class="text-primary fw-normal">${partnerData?.name} </h3><br /><div class="caption-text"></div>`,
          confirmButtonText: i18n.t('OkDelete'),
          confirmButtonColor: '#6576ff',
          allowOutsideClick: false,
          showCancelButton: true,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-light',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            removePartnerFromDraft(partnerData.generatedKey);
            Swal.fire({
              title: `${i18n.t('InvestorRemovedSuccessfully')}`,
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            });
          }
        });
      },
    },
  ];
}
export default menuOptions;
